/** Pure selection logic for forum emoji reaction button (unit-tested). */

export function tapEmojiReaction(selected: string | null, quickEmoji: string): string | null {
  if (selected) return null;
  return quickEmoji;
}

export function pickEmojiReaction(selected: string | null, emoji: string): string | null {
  if (selected === emoji) return null;
  return emoji;
}

export function emojiFromApiResponse(value: string | undefined | null): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function emojiReactionHint(selected: string | null): string {
  if (selected) {
    return 'Tap to remove your reaction, hover for more reactions';
  }
  return 'Tap for thumbs up, hover for more reactions';
}
